// extracted by mini-css-extract-plugin
module.exports = {"root":"subquestion_root__SX7lN","anserIcon":"subquestion_anserIcon__GT1s5"};